import { IElementBounds, IPositionParams, TLayout } from '../../GridLayout/grid.types'

const initPosParams: IPositionParams = {
  margin: [16, 16], // [px, px]
  containerPadding: [0, 0], // [px, px]
  containerWidth: null, // px
  cols: 8, // num
  rowHeight: 103, // px
  maxRows: 32, // num
}

const initLayout: TLayout = [
  {
    key: 'map-widget',
    x: 0,
    y: 0,
    width: 4,
    height: 4,
    bounds: {
      maxWidth: 8,
      maxHeight: 6,
    },
    children: null,
    static: false,
  },
  {
    key: 'favorite-equipment-widget',
    x: 4,
    y: 0,
    width: 2,
    height: 4,
    children: null,
    static: false,
  },
  {
    key: 'recent-notifications-widget',
    x: 6,
    y: 0,
    width: 2,
    height: 4,
    children: null,
    static: false,
  },
  {
    key: 'upcoming-maintenance-event-widget',
    x: 0,
    y: 4,
    width: 4,
    height: 4,
    children: null,
    static: false,
  },
  {
    key: 'routes-history-widget',
    x: 4,
    y: 4,
    width: 2,
    height: 4,
    children: null,
    static: false,
  },
  {
    key: 'equipment-statistics-widget',
    x: 6,
    y: 4,
    width: 2,
    height: 4,
    children: null,
    static: false,
    bounds: {
      maxWidth: 3,
      minHeight: 2,
      maxHeight: 4,
    },
  },
]

const defaultBounds: IElementBounds = {
  maxWidth: 4,
  minWidth: 2,
  minHeight: 3,
  maxHeight: 4,
}

const сurrentVersion = 1

const mainGridLayoutConstants = { initLayout, initPosParams, defaultBounds, сurrentVersion }
export default mainGridLayoutConstants
